import {
  RECEIVED_AUTH_USER,
  CLEAR_AUTH_USER,
  receivedFirebaseUser
} from '../modules/auth/actions'
import { firestore } from '../utils/firebase'

export default store => next => action => {
  switch (action.type) {
    case RECEIVED_AUTH_USER:
      next(action)

      if (action.authUser) {
        startSyncingFirebaseUser(store, action.authUser.id)
      }

      break

    case CLEAR_AUTH_USER:
      next(action)
      stopSyncingFirebaseUser()
      break

    default:
      next(action)
  }
}

let unsubscribe

export function startSyncingFirebaseUser (store, userId) {
  unsubscribe = firestore
    .collection('users')
    .doc(userId)
    .onSnapshot(userDoc => {
      store.dispatch(receivedFirebaseUser(userDoc.data()))
    })
}

export function stopSyncingFirebaseUser () {
  unsubscribe && unsubscribe()
}
